import { Flex, Typography } from "antd";
import { setTrackingOp, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { InfoMode, STEP_KEY_V2 } from "../../../../util/varibles/constants";
import { stepNameV2 } from "../../../../util/varibles/global";
import { IActivityLog, IHarvest2 } from "../../../../util/varibles/interface";
import Chip from "../../../Basic/Chip";
import SiteDisease from "../../../Operation/FishDisease/SiteDisease";
import HarvestInfo from "../../../Popup/PopupOpInfo/Info/Harvest/HarvestInfo";
import FinishStepButton from "../FinishStepButton";
import NextTabButton from "../NextTabButton";
import WeatherSection from "../WeatherSection";

export default function ArrivedSite({ log, prev, stepIndex }: { log: IActivityLog, prev?: IActivityLog, stepIndex: number }) {
    const [op] = useTrackingOp(state => state.op?.operation);
    const set = setTrackingOp();

    const isDone = !!prev?.real_start_time && !log.real_start_time;

    if (!op) return <></>;

    const { real_start_time } = log;
    return <>
        <div className="w-full">
            <Flex gap={6}>
                <Typography.Text type="secondary">Arrived at site: </Typography.Text>
                <Typography.Text>{real_start_time ? datetime(real_start_time).format("HH:mm, DD/MM") : ""}</Typography.Text>
            </Flex>
            {(op?.diseases && op?.diseases.length > 0) && <SiteDisease diseases={op?.diseases} />}
            <Flex className="mt-2 mb-[20px]" gap={6}>
                <Typography.Text type="secondary">Task: </Typography.Text>
                <Typography.Text><Chip>Harvest</Chip></Typography.Text>
            </Flex>
            <div className="mt-[5px]">
                <HarvestInfo operation={op as IHarvest2} infoMode={InfoMode.PLAN} />
            </div>
            <div className="w-full flex flex-col mt-5 items-center">
                <Typography.Title level={4} className="!mb-0">Weather Info.</Typography.Title>
                <Typography.Text className="!mb-3 block">(The weather chart will be live updated following the operation time, duration)</Typography.Text>
                <WeatherSection />
            </div>
        </div>
        {isDone
            ? <FinishStepButton name={stepNameV2(STEP_KEY_V2.ARRIVED_SITE)} payload={{ step_new: -1, current_process: stepIndex }} />
            : <NextTabButton
                sticky
                name={stepNameV2(STEP_KEY_V2.HARVESTING)}
                onClick={() => {
                    set({ step: stepIndex + 1 });
                }}
            />}
    </>
}
